<template>
  <SettingsPagePanel>
    <AccountEditorHeader
      title="ログイン情報"
      :isEditing="isEditing"
      :isButtonDisabled="isButtonDisabled || (isEditing && isInvalid.password)"
      @buttonClick="handleButtonClick"
      @cancel="handleCancel"
    />
    <SettingsTable :isEditing="isEditing">
      <SettingsTableRow name="メールアドレス">
        <p :class="$style.text">{{ props.email }}</p>
      </SettingsTableRow>

      <SettingsTableRow name="パスワード">
        <p :class="$style.text">***********</p>
        <template #editor>
          <DolphinPasswordInput
            v-model="form.password"
            @validateChange="handleValidateChange"
            ref="passwordInput"
          />
        </template>
      </SettingsTableRow>
    </SettingsTable>
  </SettingsPagePanel>
</template>

<script setup lang="ts">
import { reactive, watch, readonly } from 'vue'

import type { ValidateChangeEventParams } from '@/features/password/components/DolphinPasswordInput.vue'
import DolphinPasswordInput from '@/features/password/components/DolphinPasswordInput.vue'

import SettingsTable from '@/pages/SettingsPage/SettingsTable/SettingsTable.vue'
import SettingsTableRow from '../SettingsTable/SettingsTableRow.vue'

import AccountEditorHeader from './AccountEditorHeader.vue'

import SettingsPagePanel from '../SettingsPagePanel.vue'

export type PasswordFormValues = {
  password: string
}

const props = defineProps<{
  email: string
  isEditing: boolean
  isButtonDisabled: boolean
}>()

const emit = defineEmits<{
  (event: 'edit'): void
  (event: 'save', value: PasswordFormValues): void
  (event: 'cancel'): void
}>()

const form = reactive<PasswordFormValues>({ password: '' })
const isInvalid = reactive({ password: true })

watch(
  () => props.isEditing,
  value => {
    if (!value) {
      clearForm()
    }
  }
)

const clearForm = (): void => {
  form.password = ''
}

const handleButtonClick = (): void => {
  if (!props.isEditing) {
    emit('edit')
    return
  }
  emit('save', readonly(form))
}

const handleValidateChange = ({ isValid }: ValidateChangeEventParams): void => {
  isInvalid.password = !isValid
}

const handleCancel = (): void => {
  emit('cancel')
}
</script>

<style lang="scss" module>
.text {
  color: $color-text-and-object-high-emphasis;
  font-size: 16px;

  &:nth-child(n + 2) {
    margin-left: 16px;
  }
}
</style>
